import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useI18n } from '../../contexts/I18nContext';
import { API_BASE_URL } from '../../lib/constants';
import './ShareView.scss';

const ShareView = () => {
  const { t } = useI18n();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const text = params.get('text') || '';
  const mediaId = params.get('media') || '';
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [by, setBy] = useState(params.get('by') || '');
  const [isPortrait, setIsPortrait] = useState(false);
  const vref = useRef(null);
  
  const getAbsoluteUrl = (url) => {
    if (!url) return '';
    return url.startsWith('http') ? url : `${API_BASE_URL}${url}`;
  };
  useEffect(() => {
    const run = async () => {
      if (!mediaId) return;
      setLoading(true);
      try {
        const res = await fetch(`/api/share/${mediaId}`);
        if (!res.ok) throw new Error(String(res.status));
        const json = await res.json();
        if (json && json.success && json.data) {
          setData(json.data);
          if (json.data.userName) setBy(json.data.userName);
        }
      } catch (e) {}
      setLoading(false);
    };
    run();
  }, [mediaId]);

  const onMeta = () => {
    const el = vref.current;
    if (!el) return;
    setIsPortrait((el.videoHeight || 0) > (el.videoWidth || 0));
  };

 

  return (
    <div className="share-view">
      <div className="share-card">
        <div className="share-header">
          <div className="brand">Catoo AI</div>
          {by && data ? (
            <div className="by">{t('shareView.sharedBy')} {by}</div>
          ) : null}
        </div>
        <div className="media-area">
          {loading ? (
            <div className="media placeholder" />
          ) : (!data || (!data.videoUrl && !data.imageUrl)) ? (
            <div className="empty-state">
              <div className="empty-icon">🚫</div>
              <div className="empty-title">Data not found.</div>
              <div className="empty-subtitle">The content has been canceled or deleted by the sharer.</div>
            </div>
          ) : (data.videoUrl ? (
            <video
              src={getAbsoluteUrl(data.videoUrl)}
              controls
              playsInline
              className={`media video ${isPortrait ? 'portrait' : 'landscape'}`}
              poster={getAbsoluteUrl(data.imageUrl || '')}
              onLoadedMetadata={onMeta}
              ref={vref}
            />
          ) : (
            <img src={getAbsoluteUrl(data.imageUrl)} alt="shared" className="media" />
          ))}
        </div>
        <div className="text-area">{text}</div>
      </div>
    </div>
  );
};

export default ShareView;
